import { Component, Input, OnInit } from '@angular/core';
import { CRMItem } from '../../models/crm/CRMItem.model';
import { CrmNoteService } from '../../../core/data-services/crm-note.service';
import { Reference } from '../../models';
import { BannerNotificationsService } from '../../../xform-compat';
import { CompanyNotesService, CompanyService } from '../../../core/data-services/company';
import { forkJoin } from 'rxjs';
import { TextContentService } from '../../../core/services';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'rms-crm-references-panel',
    templateUrl: './crm-references-panel.component.html',
    styleUrls: ['./crm-references-panel.component.scss'],
    standalone: false
})
export class CrmReferencesPanelComponent implements OnInit {

  @Input() crmItem: CRMItem;

  public split = false;

  public references: Array<Reference>;
  public companyReferences: Array<Reference & {isPrivate: boolean, ticker: string}>;


  constructor(
    private crmNoteService: CrmNoteService,
    private companyService: CompanyService,
    private companyNotesService: CompanyNotesService,
    private bannerNotificationService: BannerNotificationsService,
  ) { }

  ngOnInit() {
    this.fetchAllCrmReferences();
    this.companyNotesService.getMessage().subscribe(() => this.fetchAllCrmReferences());
  }

  public handleSplit(event) {
    event.stopPropagation();
    this.split = !this.split;
  }

  public getPrivates() {
    return this.companyReferences && this.companyReferences.filter(cr => cr.isPrivate);
  }

  public getPublics() {
    return this.companyReferences && this.companyReferences.filter(cr => !cr.isPrivate);
  }

  private fetchAllCrmReferences() {
    this.crmNoteService.getAllNoteReferences(this.crmItem.id).subscribe(value => {
        this.references = value;
        this.companyReferences = value.filter(v => v.referencedType === 'COMPANY');
        this.companyReferences.sort((a, b) => a.referencedLabel > b.referencedLabel ? 1 : -1);
        forkJoin(this.companyReferences.map(ref => this.companyService.getCompany(ref.referencedId)))
          .subscribe(companies => {
            this.companyReferences = this.companyReferences.map(cr => {
              const match = companies.find(c => c.id === +cr.referencedId);
              return {
                ...cr,
                isPrivate: match.isPrivate,
                ticker: match.ticker,
              };
            });
          });
    },
    error => this.bannerNotificationService.error(error));

  }
}
